const coalesce = (...values) => values.find((v) => v !== undefined);
export { coalesce };
//# sourceMappingURL=coalesce.js.map